<template>
  <div class="epicrisis-wrapper">
    <div class="epicrisis-redactor-field">
      <div class="epicrisis-redactor-field-field-disabled" v-if="disabled" v-html="value"></div>
      <redactor v-model="value" v-if="!disabled" :config="redactorConfig"></redactor>
    </div>
      <epicrisis-pattern :applicationId="$route.params.id" @select="selectEpicrisis($event)" />
  </div>
</template>

<script>
  import { abstractField } from 'vue-form-generator'
  import { set } from 'lodash'
  import redactor from './redactor/RedactorVue'
  import EpicrisisPattern from '../../../pages/private/applications/epicrisis-pattern';

  export default {
    mixins: [abstractField],
    components: {
      redactor,
      EpicrisisPattern,
    },
    name: 'Epicrisis',
    computed: {
      redactorConfig() {
        return {
          clickToEdit: true,
          lang: 'sk',
          removeNewLines: true,
          buttons: ['undo', 'redo', 'html', 'format', 'bold', 'italic', 'underline', 'sup', 'sub', 'deleted', 'lists', 'image', 'file', 'link', 'line', 'ol', 'ul', 'indent', 'outdent'],
          placeholder: this.schema.placeholder,
          callbacks: {},
        }
      },
    },
    methods: {
      selectEpicrisis(event) {
        set(this.model, this.schema.model, event.text)
      }
    }
    // mounted() {
    //   console.log({a: this.model})
    //   setTimeout(() => {
    //     console.log('hello', this.schema)
    //     set(this.model, this.schema.model,  'hello2redactor')
    //   }, 5000)
    // }
  }
</script>

<style lang="scss">
  @import './redactor/_scss/redactor';

  .epicrisis-wrapper {
    display: flex;
    width: 100%;

    .epicrisis-redactor-field {
      flex: 1;

      .epicrisis-redactor-field-field-disabled {
        border: 1px solid #ced4da;
        padding: 8px 12px;
        border-radius: 4px;
        min-height: 38px;
        opacity: .6;
      }
    }

    .redactor-box.redactor-styles-on {
      border-color: #ced4da;
      border-radius: .25rem 0 0 .25rem !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/core/Form/Fields/Epicrisis.vue